export default {
  MuiIconButton: {
    root: {
      '&:hover': {
        backgroundColor: 'none',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/IconButton.js